import { SwitchTransition, CSSTransition } from "react-transition-group";
import { useRouter } from "next/router";
import { ReactNode, useRef } from "react";

interface PageTransitionProps {
  children: ReactNode;
}

const PageTransition = ({ children }: PageTransitionProps) => {
  const router = useRouter();
  const nodeRef = useRef<HTMLDivElement>(null);
  const pathOnly = router.asPath.split("?")[0];
  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={pathOnly}
        nodeRef={nodeRef}
        timeout={{ enter: 300, exit: 0 }}
        classNames="fade"
        unmountOnExit
      >
        <div ref={nodeRef} className={"page-transition-wrapper"}>
          {children}
        </div>
      </CSSTransition>
    </SwitchTransition>
  );
};

export default PageTransition;
